import React from "react";

export const RichText = ({ html, className = "" }) => (
  <div
    className={`prose-wedding ${className}`}
    dangerouslySetInnerHTML={{ __html: html || "" }}
  />
);

export default RichText;
